import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Menu, MenuItem, Tooltip } from '@mui/material';
import { CustomerGroupBrief } from '../../types/customerGroups';
import { groupButtonLabel, groupMenuRowLabel, groupPagePath, isTruncated } from './groupLabels';

/** Asztali fejléc: a tagnak MINDIG legfeljebb egy kiemelt csoport-gomb (spec 3/b, „A”). */
export default function GroupHeaderButton({ groups }: { groups: CustomerGroupBrief[] }) {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  if (groups.length === 0) return null;

  if (groups.length === 1) {
    const group = groups[0];
    return (
      <Tooltip title={group.name} disableHoverListener={!isTruncated(group.name)}>
        <RouterLink to={groupPagePath(group.slug)} className="ha grp" aria-label={`${group.name} csoport termékei`}>
          {groupButtonLabel(groups)}
        </RouterLink>
      </Tooltip>
    );
  }

  return (
    <>
      <button
        type="button"
        className="ha grp"
        aria-haspopup="true"
        aria-expanded={Boolean(anchor)}
        onClick={(e) => setAnchor(e.currentTarget)}
      >
        {groupButtonLabel(groups)}
        <span aria-hidden="true"> ▾</span>
      </button>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
        {groups.map((group) => (
          <MenuItem key={group.id} component={RouterLink} to={groupPagePath(group.slug)} onClick={() => setAnchor(null)}>
            {groupMenuRowLabel(group)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
